export const $ProductComparisonSkuListModuleName = "productComparisonSkuList";

export type TProductComparisonSkuListState = Array<string>;
